import { NoticePage } from './NoticePage'
import { AUTH_LIBERTY_TITLE, AUTH_LIBERTY_CONTENT } from './disclosureContent'

export function AuthorizationForLibertyNotice() {
  return (
    <NoticePage
      title={AUTH_LIBERTY_TITLE}
      content={AUTH_LIBERTY_CONTENT}
      linkType="authorization_for_liberty"
    />
  )
}
